// extracted by mini-css-extract-plugin
export default {"content":"VpcKy5wbtd3jDf9k3Pn0","frozenColumn":"OLk6QEMIiFfGAuOJBgEi"};